import gql from 'graphql-tag';

export const createAdyenAccount = gql`
	mutation CreateAdyenAccount($input: AdyenAccountInput) {
		createAdyenAccount(input: $input) {
			merchantId
			storeId
			storeReference
			regionCode
			currencyCode
		}
	}
`;

export const getAdyenAccount = gql`
	query GetAdyenAccount {
		getAdyenAccount {
			merchantId
			storeId
			storeReference
			regionCode
			currencyCode
		}
	}
`;

// export const deleteAdyenAccount = gql`
// 	mutation deleteAdyenAccount {
// 		deleteAdyenAccount
// 	}
// `;

export const deleteAdyenAccount = gql`
	mutation deleteAdyenAccount($confirmationText: String!) {
		deleteAdyenAccount(confirmationText: $confirmationText) {
			errmsg
		}
	}
`;

// Query used to retrieve list of adyen terminals
export const listAdyenTerminals = gql`
	query adyenTerminals {
		adyenTerminals {
			terminalId
			terminalName
			terminalModel
		}
	}
`;

export const GET_MERCHANT_LIST = gql`
	query GetMerchantList {
		getMerchantList {
			label
			value
		}
	}
`;

// Mutation used to update a adyen Terminal
export const updateAdyenTerminal = gql`
	mutation updateAdyenTerminal($input: AdyenTerminalInput) {
		updateAdyenTerminal(input: $input) {
			terminalId
			terminalName
			terminalModel
		}
	}
`;

export const getTimeZone = gql`
	query GetTimeZone {
		getTimeZone {
			timezone
		}
	}
`;

export default {
	createAdyenAccount,
	getAdyenAccount,
	deleteAdyenAccount,
	listAdyenTerminals,
	updateAdyenTerminal,
};
